/* https://css-tricks.com/the-shapes-of-css/ */
/* https://csshexagon.com/ */

/* http://jsfiddle.net/danield770/jXK5C/1/ */
.octagon {
  height: 300px;
  overflow: hidden;
  position: relative;
  transform: rotate(45deg);
  width: 300px;
}
.octagon:before {
  background: var(--ds-poker-green-lighter);
  bottom: 0;
  content: '';
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: rotate(-45deg);
}
